import { useModel } from "@type-r/react";
import React from "react";
import { AssetType } from "../../api/assetType";
import { CustomerReferenceData, CustomerReferenceDataCount, CustomerReferenceDataObject } from "../../api/customerReferenceData";
import { ConfirmAssetsDataStep } from "../confirm-assets-data-step";
import { CustomerReferenceDataForm } from "./customer-reference-data-form";
import { CustomerReferenceDataQuerry } from "./customer-reference-data-query";
import { CustomerReferenceDataTableColumns } from "./customer-reference-data-table-columns";
import { CustomerReferenceDataExternalSystems } from "./externalSystems";

export const ConfirmCustomerReferenceDataStep = ({ isEdit, job, next, cancel, startOver, $assetTypeSelect, assetTypeMultiOptions, $refreshEvents }:
    { isEdit: boolean, job, next?, cancel?, startOver?, $assetTypeSelect?, assetTypeMultiOptions?, $refreshEvents?}) => {
    const customerReferenceDataChanges = useModel(CustomerReferenceDataObject);
    const customerReferenceDataCountModel = useModel(CustomerReferenceDataCount);
    const customerReferenceDataQuerryModel = useModel(CustomerReferenceDataQuerry);
    return <>
        <ConfirmAssetsDataStep
            isEdit={isEdit}
            job={job}
            assetName="Customer Reference Data"
            assetType={AssetType.customerReferenceData}
            assetModel={CustomerReferenceData}
            countModel={customerReferenceDataCountModel}
            queryModel={customerReferenceDataQuerryModel}
            tableColumns={CustomerReferenceDataTableColumns}
            assetChanges={customerReferenceDataChanges}
            next={next} cancel={cancel} startOver={startOver}
            externalSystems={CustomerReferenceDataExternalSystems}
            assetForm={crd => <CustomerReferenceDataForm crd={crd} />}
            $assetTypeSelect={$assetTypeSelect}
            assetTypeMultiOptions={assetTypeMultiOptions}
            $refreshEvents={$refreshEvents}
        />
    </>
}